import React from 'react';
import {LandingPagePropTypes, NeuroMessage} from '@ignitesales/neuro-application';
import {GuideNameMessage, WelcomeMessage, WelcomeTitle} from "../../../../../../../shared/js";

const LandingPage = ({ componentClass, onStartGuideClick, isLoadingNextPage }) => {
    return (
        <div className={componentClass}>
            <img src={"/classpath/assets/images/background-curve.png"} alt="background-curve" className={`${componentClass}__background`} />
            <div className="container">
                <div className={`${componentClass}__card`}>
                    <div className="titleSection">
                        <GuideNameMessage />
                    </div>
                    <div className="imageSection">
                        <div className="img" />
                        <WelcomeTitle tagName="h1" />
                    </div>
                    <div className="contentSection">
                        <WelcomeMessage tagName="span" />
                        <button onClick={() => onStartGuideClick('none')} disabled={isLoadingNextPage} className="btn btn-primary">
                            <NeuroMessage id="landing.readyToStart" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

LandingPage.propTypes = LandingPagePropTypes;

export default LandingPage;
